import api from './api';

/**
 * Framework service for interacting with the frameworks API.
 */
const frameworkService = {
  /**
   * Get all frameworks.
   * 
   * @returns {Promise} Promise that resolves to the list of frameworks
   */
  getAllFrameworks: async () => {
    try {
      // Since baseURL already includes /api, we don't need to include it in the path
      const response = await api.get('/v1/frameworks');
      console.log('Framework response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching frameworks:', error);
      throw error;
    }
  },

  /**
   * Get a specific framework with its steps.
   * 
   * @param {string} frameworkId - The ID of the framework to get
   * @returns {Promise} Promise that resolves to the framework with its steps
   */
  getFramework: async (frameworkId) => {
    try {
      // Since baseURL already includes /api, we don't need to include it in the path
      const response = await api.get(`/v1/frameworks/${frameworkId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching framework ${frameworkId}:`, error);
      throw error;
    }
  },

  /**
   * Update the completion status of a step.
   * 
   * @param {string} stepId - The ID of the step to update
   * @param {boolean} completed - Whether the step is completed
   * @returns {Promise} Promise that resolves to the updated step
   */
  updateStepCompletion: async (stepId, completed) => {
    try {
      // Since baseURL already includes /api, we don't need to include it in the path
      const response = await api.post(`/v1/frameworks/steps/${stepId}/completion`, {
        step_id: stepId,
        completed
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating step ${stepId} completion:`, error);
      throw error;
    }
  },

  /**
   * Get the completion status of a step.
   * 
   * @param {string} stepId - The ID of the step
   * @returns {Promise} Promise that resolves to the completion status
   */
  getStepCompletion: async (stepId) => {
    try {
      // Since baseURL already includes /api, we don't need to include it in the path
      const response = await api.get(`/v1/frameworks/steps/${stepId}/completion`);
      return response.data.completed;
    } catch (error) {
      console.error(`Error getting step ${stepId} completion:`, error);
      throw error;
    }
  }
};

export default frameworkService;